import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { EstacionesState } from '@/store/modules/estaciones/types'

export const getters: GetterTree<EstacionesState, RootState> = {
  getGrupoTipoVariable (state: EstacionesState) {
    return state.grupoTipoVariable
  },
  getTipoVariables (state: EstacionesState) {
    return state.tipoVariable.tipo_variable_list
  },
  getEstacionesTipoVariable (state: EstacionesState) {
    return state.tipoVariable.estacion_list
  },
  getEstaciones (state: EstacionesState) {
    return state.estaciones.estacion_list
  },
  getEstacion (state: EstacionesState) {
    return state.dataEstacion
  }
}
